import { useNode } from '@craftjs/core';
import React, { useCallback } from 'react';
import { Loader } from '@descope/page-editor-components';
import { EditorLoaderSettings } from './EditorLoaderSettings';

type Props = React.ComponentProps<typeof Loader> & {
	// eslint-disable-next-line react/require-default-props
	'data-type'?: string;
};

const EditorLoader = (props: Props) => {
	const {
		connectors: { connect, drag }
	} = useNode();

	const refCb = useCallback(
		(ref: HTMLDivElement) => connect(drag(ref)),
		[connect, drag]
	);

	return <Loader ref={refCb} {...props} />;
};

EditorLoader.craft = {
	name: 'Loader',
	props: {
		size: 'md' as Props['size'],
		variant: 'linear' as Props['variant'],
		color: 'primary' as Props['color'],
		'data-type': 'loader'
	},
	related: {
		settings: EditorLoaderSettings
	}
};

export { EditorLoader };
